import { FormScrollService } from "front-end/components/sections/forms-section/form-scroll.service";
import { FormsTabService } from "front-end/components/sections/forms-section/forms-tab.service";

export class FormsSectionService {

    private initTabService(context: JQuery): void {
        const tabService = new FormsTabService();
        tabService.init(context);
    }

    private initScrollService(context: JQuery): void {
        const scrollService = new FormScrollService();
        scrollService.init(context);
    }

    public init(context: JQuery): void {
        this.initTabService(context);
        this.initScrollService(context);
    }
}
